export default __webpack_public_path__ + "static/media/kitchen3-afterE-1920w.66fc1781.avif";